(function () {
  var cfg = window.__HAVIN_VARIANT_MEDIA__ || {};
  if (!cfg.productId) return;

  var variantImages = cfg.variantImages || {};
  var variantDescriptions = cfg.variantDescriptions || {};
  var productDescriptionHtml = cfg.productDescription || "";
  var optionSwatches = cfg.optionSwatches || {};
  var baseTitle = String(cfg.baseTitle || "").trim();
  var initialTitle = String(cfg.initialTitle || "").trim();
  var initialColor = String(cfg.initialColor || "").trim();
  var product = null;
  var featuredEl = null;
  var titleEl = null;
  var reinitTimer = null;
  var lastUrlVariant = null;

  var COLOR_HEX = {
    beige: "#F5F5DC",
    black: "#111111",
    white: "#F8F8F8",
    red: "#C41E3A",
    scarlet: "#FF2400",
    pink: "#FF69B4",
    pout: "#FF69B4",
    rose: "#C08081",
    brown: "#8B4513",
    mocha: "#967969",
    nude: "#E3BC9A",
    coral: "#FF7F50",
    mauve: "#E0B0FF",
    berry: "#7A1F3D",
    wine: "#722F37",
    navy: "#001F3F",
    blue: "#1E3A8A",
    green: "#166534",
    purple: "#6B21A8",
    orange: "#EA580C",
    peach: "#FFCBA4",
    terracotta: "#E2725B",
    cherry: "#DE3163",
    dusty: "#D4A59A",
    yellow: "#EAB308",
    gray: "#6B7280",
    grey: "#6B7280",
    pop: "#FF1493",
  };

  function guessHex(name) {
    var n = String(name || "").toLowerCase();
    var keys = Object.keys(COLOR_HEX);
    for (var i = 0; i < keys.length; i += 1) {
      if (n.indexOf(keys[i]) !== -1) return COLOR_HEX[keys[i]];
    }
    return "";
  }

  function loadProduct() {
    if (window.Shopify && window.Shopify.product) return window.Shopify.product;

    var knownIds = [
      "WH-ProductJson-product-template",
      "ProductJson-product-template",
      "ProductJson",
    ];
    for (var i = 0; i < knownIds.length; i += 1) {
      var node = document.getElementById(knownIds[i]);
      if (!node || !node.textContent) continue;
      try {
        var parsed = JSON.parse(node.textContent);
        if (parsed && parsed.variants) return parsed;
      } catch (e) {}
    }

    var picker = document.querySelector("variant-picker");
    if (picker) {
      var sectionId = picker.getAttribute("data-section-id");
      if (sectionId) {
        var sectionScript = document.getElementById("ProductJson-" + sectionId);
        if (sectionScript && sectionScript.textContent) {
          try {
            var sectionData = JSON.parse(sectionScript.textContent);
            if (sectionData && sectionData.variants) return sectionData;
          } catch (e2) {}
        }
      }
    }

    var scripts = document.querySelectorAll('script[type="application/json"]');
    for (var j = 0; j < scripts.length; j += 1) {
      var text = scripts[j].textContent || "";
      if (text.indexOf('"variants"') === -1) continue;
      try {
        var data = JSON.parse(text);
        if (data && data.variants && data.id) return data;
      } catch (e3) {}
    }
    return null;
  }

  function ensureProductThen(fn) {
    product = loadProduct() || product;
    if (product && product.variants) {
      fn();
      return;
    }
    var picker = document.querySelector("variant-picker");
    var handle = picker && picker.getAttribute("data-product-handle");
    if (!handle || ensureProductThen._loading) {
      fn();
      return;
    }
    ensureProductThen._loading = true;
    fetch("/products/" + encodeURIComponent(handle) + ".js", {
      credentials: "same-origin",
    })
      .then(function (res) {
        if (!res.ok) throw new Error("product.js " + res.status);
        return res.json();
      })
      .then(function (data) {
        if (data && data.variants) product = data;
      })
      .catch(function () {})
      .then(function () {
        ensureProductThen._loading = false;
        fn();
      });
  }

  function refreshDomRefs() {
    featuredEl =
      document.querySelector(
        ".product-information__media .product-media__image.is-active"
      ) ||
      document.querySelector(".product-information__media .product-media__image") ||
      document.querySelector("media-gallery .product-media__image.is-active") ||
      document.querySelector("media-gallery .product-media__image") ||
      document.querySelector("[data-havin-featured-media] img") ||
      document.querySelector(".product__media img") ||
      document.querySelector(".product-media img") ||
      document.querySelector('[data-media-type="image"] img') ||
      document.querySelector(".product__main-photos img");

    titleEl =
      document.querySelector('.product-details [data-havin-variant-title="1"]') ||
      document.querySelector(".product-details .text-block h4") ||
      document.querySelector('.product-details a[ref="productTitleLink"] p[role="heading"]') ||
      document.querySelector('.product-details a[data-havin-variant-title-link="1"] p[role="heading"]') ||
      document.querySelector(".product-details .text-block p[role='heading']") ||
      document.querySelector(".product-information .view-product-title") ||
      document.querySelector(".view-product-title") ||
      document.querySelector("h1.product__title") ||
      document.querySelector("h1.product-title") ||
      document.querySelector(".product__title h1") ||
      document.querySelector(".product-single__title") ||
      null;
  }

  function applyInitialTitle() {
    refreshDomRefs();
    if (!titleEl) return;
    var variant = currentVariant();
    if (titleEl.getAttribute("data-havin-variant-title") === "1") {
      if (variant && titleNeedsFix()) applyTitleNow(variant);
      return;
    }
    if (initialTitle) {
      titleEl.textContent = initialTitle;
      return;
    }
    if (variant) applyTitleNow(variant);
  }

  refreshDomRefs();

  if (!baseTitle && titleEl) {
    baseTitle = String(titleEl.textContent || "")
      .replace(/\s*\([^)]*\)\s*$/, "")
      .trim();
  }

  product = loadProduct();

  function optionNameAt(index) {
    if (!product || !product.options || !product.options[index]) return "";
    var opt = product.options[index];
    if (typeof opt === "string") return opt;
    return (opt && opt.name) || "";
  }

  function isPlaceholderOption(value) {
    var v = String(value || "").trim().toLowerCase();
    return !v || v === "default title" || v === "default";
  }

  function colorLabelFromVariant(variant) {
    if (!variant || !product) return "";
    var idx = colorOptionIndex();
    var label = "";
    if (idx === 0) label = variant.option1 || "";
    else if (idx === 1) label = variant.option2 || "";
    else if (idx === 2) label = variant.option3 || "";
    // Do not fall back to option1 for Title/Default Title products
    if (isPlaceholderOption(label)) return "";
    return String(label).trim();
  }

  function variantOptionLabel(variant) {
    if (!variant) return "";
    return [variant.option1, variant.option2, variant.option3]
      .map(function (v) {
        return String(v || "").trim();
      })
      .filter(function (v) {
        return !isPlaceholderOption(v);
      })
      .join(" / ");
  }

  function listingTitle(variant) {
    var label = colorLabelFromVariant(variant);
    if (!label) label = variantOptionLabel(variant);
    if (!baseTitle) return label || "";
    if (!label) return baseTitle;
    return baseTitle + " (" + label + ")";
  }

  function optionKeyFromVariant(variant) {
    if (!variant) return "";
    return [variant.option1 || "", variant.option2 || "", variant.option3 || ""]
      .join("|")
      .trim();
  }

  function normalizeOptionKey(key) {
    return String(key || "")
      .trim()
      .toLowerCase()
      .replace(/[_-]+/g, " ")
      .replace(/\s+/g, " ");
  }

  function urlsForVariant(variant) {
    var key = optionKeyFromVariant(variant);
    if (!key) return [];
    if (Object.prototype.hasOwnProperty.call(variantImages, key)) {
      var mappedExact = variantImages[key];
      if (Array.isArray(mappedExact) && mappedExact.length) return mappedExact;
    }
    // Fuzzy match: CRM may store "Cat Eye" while Shopify serves "Cat-eye".
    var norm = normalizeOptionKey(key);
    if (norm) {
      var keys = Object.keys(variantImages || {});
      for (var i = 0; i < keys.length; i += 1) {
        if (normalizeOptionKey(keys[i]) !== norm) continue;
        var mapped = variantImages[keys[i]];
        if (Array.isArray(mapped) && mapped.length) return mapped;
      }
    }
    return [];
  }

  function hasVariantImageMap() {
    // Keys with empty lists (e.g. size-only variants) are not a variant gallery.
    var keys = Object.keys(variantImages || {});
    for (var i = 0; i < keys.length; i += 1) {
      var list = variantImages[keys[i]];
      if (Array.isArray(list) && list.length) return true;
    }
    return false;
  }

  function hideAllGalleryMedia() {
    var selectors = [
      "media-gallery slideshow-slide",
      "media-gallery .media-gallery__grid > li",
      "media-gallery .slideshow-controls__thumbnail",
      "zoom-dialog .dialog-thumbnails-list__thumbnail",
      "zoom-dialog ul.dialog-zoomed-gallery > li",
    ];
    for (var s = 0; s < selectors.length; s += 1) {
      var nodes = document.querySelectorAll(selectors[s]);
      for (var i = 0; i < nodes.length; i += 1) {
        hideGalleryNode(nodes[i]);
      }
    }
  }

  function showMediaById(mediaId) {
    if (!mediaId) return;
    var nodes = document.querySelectorAll(
      '[data-media-id="' +
        mediaId +
        '"], [data-media-id="' +
        mediaId +
        '"]'
    );
    // Prefer gallery slides / thumbs that carry the id
    var all = document.querySelectorAll(
      "media-gallery slideshow-slide, media-gallery .slideshow-controls__thumbnail, media-gallery .media-gallery__grid > li"
    );
    for (var i = 0; i < all.length; i += 1) {
      var el = all[i];
      var id =
        el.getAttribute("data-media-id") ||
        (el.querySelector("[data-media-id]") &&
          el.querySelector("[data-media-id]").getAttribute("data-media-id"));
      if (String(id) === String(mediaId)) showGalleryNode(el);
    }
  }

  function filterGalleryForVariant(variant) {
    if (!variant) return;
    var urls = urlsForVariant(variant);
    if (!urls.length) {
      // Never dump the full product gallery when a variant map exists but the
      // option key missed — that was the SA30 Cat-eye / Doll-eye bleed.
      if (hasVariantImageMap()) {
        resetGalleryVisibility();
        hideAllGalleryMedia();
        if (variant.featured_media || variant.featured_image) {
          var feat =
            (variant.featured_media && variant.featured_media.id) ||
            (variant.featured_image && variant.featured_image.id);
          if (feat) showMediaById(String(feat));
        }
        syncSlideshowAfterFilter(1, 1);
      } else {
        resetGalleryVisibility();
      }
      return;
    }

    resetGalleryVisibility();

    var allowedUrlKeys = {};
    for (var u = 0; u < urls.length; u += 1) {
      allowedUrlKeys[normalizeMediaUrl(urls[u])] = true;
    }

    var allowedIds = {};
    if (variant.featured_media && variant.featured_media.id) {
      allowedIds[String(variant.featured_media.id)] = true;
    }
    if (variant.featured_image && variant.featured_image.id) {
      allowedIds[String(variant.featured_image.id)] = true;
    }

    var counts = { visible: 0, firstVisible: null, uniqueKeys: {} };

    function noteVisible(el) {
      counts.visible += 1;
      if (!counts.firstVisible) counts.firstVisible = el;
      var img = el.querySelector("img.product-media__image, img");
      if (img) {
        var normUrl = normalizeMediaUrl(
          img.currentSrc || img.src || img.getAttribute("src") || ""
        );
        if (normUrl) counts.uniqueKeys[normUrl] = true;
      }
    }

    filterGalleryNodes("media-gallery slideshow-slide", allowedUrlKeys, allowedIds, counts, noteVisible);
    filterGalleryNodes(
      "media-gallery .media-gallery__grid > li",
      allowedUrlKeys,
      allowedIds,
      counts,
      noteVisible
    );
    filterGalleryNodes(
      "media-gallery .slideshow-controls__thumbnail",
      allowedUrlKeys,
      allowedIds,
      counts
    );
    filterGalleryNodes(
      "zoom-dialog .dialog-thumbnails-list__thumbnail",
      allowedUrlKeys,
      allowedIds,
      counts
    );
    filterGalleryNodes(
      "zoom-dialog ul.dialog-zoomed-gallery > li",
      allowedUrlKeys,
      allowedIds,
      counts,
      noteVisible
    );

    var displayCount = Object.keys(counts.uniqueKeys).length || urls.length;
    syncSlideshowAfterFilter(counts.visible, displayCount);

    if (!counts.firstVisible && urls[0]) {
      swapFeatured(urls[0]);
    }
  }

  function stripShopifySizeSuffix(filename) {
    return String(filename || "").replace(
      /_(?:\d+x\d*|\d*x\d+)(?:@[0-9.]+)?(?:_crop_[a-z]+)?(?=\.[a-z0-9]+$)/i,
      ""
    );
  }

  function stripImageUuid(filename) {
    return String(filename || "")
      .split("/")
      .pop()
      .replace(
        /_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?=\.[a-z0-9]+$)/i,
        ""
      );
  }

  function normalizeMediaUrl(url) {
    if (!url) return "";
    try {
      var u = new URL(url, window.location.origin);
      var parts = u.pathname.split("/files/");
      var filename =
        parts.length > 1 ? parts[parts.length - 1] : u.pathname.split("/").pop();
      // Strip CDN size transforms first; keep UUID so shades don't collide as "1.jpg".
      return stripShopifySizeSuffix(String(filename || "").split("?")[0]);
    } catch (e) {
      return stripShopifySizeSuffix(
        String(url).split("?")[0].split("#")[0].split("/").pop() || ""
      );
    }
  }

  function urlsMatchAllowed(src, allowedUrlKeys) {
    var norm = normalizeMediaUrl(src);
    return !!(norm && allowedUrlKeys[norm]);
  }

  function itemMatchesVariantMedia(el, allowedUrlKeys, allowedIds) {
    var mediaId =
      el.getAttribute("data-media-id") ||
      (el.querySelector("[data-media-id]") &&
        el.querySelector("[data-media-id]").getAttribute("data-media-id"));
    if (mediaId && allowedIds[String(mediaId)]) return true;
    var img = el.querySelector("img.product-media__image, img");
    if (img) {
      var src = img.currentSrc || img.src || img.getAttribute("src") || "";
      if (urlsMatchAllowed(src, allowedUrlKeys)) return true;
    }
    return false;
  }

  function showGalleryNode(el) {
    if (!el) return;
    el.style.removeProperty("display");
    el.removeAttribute("hidden");
    el.removeAttribute("data-havin-filter-hidden");
    el.removeAttribute("data-havin-gallery-hidden");
    el.removeAttribute("aria-hidden");
    if (el.tagName === "BUTTON") {
      el.removeAttribute("tabindex");
    }
  }

  function hideGalleryNode(el) {
    if (!el) return;
    el.style.removeProperty("display");
    el.setAttribute("hidden", "");
    el.setAttribute("data-havin-filter-hidden", "1");
    el.setAttribute("data-havin-gallery-hidden", "1");
    if (el.tagName === "BUTTON") {
      el.setAttribute("tabindex", "-1");
    }
  }

  function resetGalleryVisibility() {
    var nodes = document.querySelectorAll(
      '[data-havin-filter-hidden="1"], [data-havin-gallery-hidden="1"]'
    );
    for (var i = 0; i < nodes.length; i += 1) {
      showGalleryNode(nodes[i]);
    }
    syncSlideshowAfterFilter(null);
  }

  function getSlideshowComponent(mediaGallery) {
    if (!mediaGallery) return null;
    if (mediaGallery.refs && mediaGallery.refs.slideshow) {
      return mediaGallery.refs.slideshow;
    }
    return mediaGallery.querySelector("slideshow-component");
  }

  function syncSlideshowAfterFilter(visibleCount, displayCount) {
    var galleries = document.querySelectorAll("media-gallery");
    for (var g = 0; g < galleries.length; g += 1) {
      var gallery = galleries[g];
      var slideshow = getSlideshowComponent(gallery);
      var count = visibleCount;
      var counterTotal = displayCount != null ? displayCount : visibleCount;

      if (count == null && slideshow && typeof slideshow.slides !== "undefined") {
        count = slideshow.slides.length;
      }
      if (counterTotal == null) counterTotal = count;

      // Horizon bakes absolute on:click="/select/N" at render time. After we
      // hide slides, slideshow.slides is the filtered list — remap visible
      // thumbs to contiguous 0..n-1 so later variants' thumbs work.
      remapVisibleThumbnailSelects(gallery);

      if (slideshow && typeof slideshow.select === "function") {
        try {
          slideshow.select(0, undefined, { animate: false });
        } catch (e) {
          /* ignore select errors during morph */
        }
      }

      var counter = gallery.querySelector(".slideshow-controls__counter");
      if (counter) {
        if (counterTotal != null && counterTotal > 1) {
          counter.textContent = "1 / " + counterTotal;
          counter.style.removeProperty("display");
        } else if (counterTotal != null && counterTotal <= 1) {
          counter.style.display = "none";
        }
      }

      var navControls = gallery.querySelectorAll(
        "slideshow-arrows .slideshow-control, [data-action='next'], [data-action='prev']"
      );
      for (var n = 0; n < navControls.length; n += 1) {
        navControls[n].style.display = counterTotal != null && counterTotal <= 1 ? "none" : "";
      }

      var thumbContainer = gallery.querySelector(".slideshow-controls__thumbnails");
      if (thumbContainer) {
        thumbContainer.style.display = counterTotal != null && counterTotal <= 1 ? "none" : "";
      }
    }
  }

  function remapVisibleThumbnailSelects(gallery) {
    if (!gallery) return;
    var slideshow = getSlideshowComponent(gallery);
    var thumbs = gallery.querySelectorAll(
      ".slideshow-controls__thumbnail, .dialog-thumbnails-list__thumbnail"
    );
    var visibleIndex = 0;
    for (var i = 0; i < thumbs.length; i += 1) {
      var thumb = thumbs[i];
      if (
        thumb.hasAttribute("hidden") ||
        thumb.getAttribute("data-havin-filter-hidden") === "1"
      ) {
        continue;
      }
      var idx = visibleIndex;
      visibleIndex += 1;
      thumb.setAttribute("on:click", "/select/" + idx);
      thumb.setAttribute("data-havin-select-index", String(idx));
      // Horizon may ignore attribute updates after connect — drive select ourselves.
      if (!thumb.__havinThumbBound) {
        thumb.__havinThumbBound = true;
        thumb.addEventListener(
          "click",
          function (ev) {
            var t = ev.currentTarget;
            var selectIdx = Number(t.getAttribute("data-havin-select-index"));
            if (!Number.isFinite(selectIdx)) return;
            var root = t.closest("media-gallery") || gallery;
            var ss = getSlideshowComponent(root) || slideshow;
            if (ss && typeof ss.select === "function") {
              ev.preventDefault();
              ev.stopPropagation();
              try {
                ss.select(selectIdx, undefined, { animate: true });
              } catch (e) {
                /* ignore */
              }
            }
          },
          true
        );
      }
    }
  }

  function filterGalleryNodes(selector, allowedUrlKeys, allowedIds, counts, onShow) {
    var nodes = document.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i += 1) {
      var el = nodes[i];
      if (itemMatchesVariantMedia(el, allowedUrlKeys, allowedIds)) {
        showGalleryNode(el);
        if (onShow) onShow(el);
        else counts.visible += 1;
        if (!counts.firstVisible) counts.firstVisible = el;
      } else {
        hideGalleryNode(el);
      }
    }
  }

  function swapFeatured(url) {
    refreshDomRefs();
    if (!url || !featuredEl) return;
    featuredEl.src = url;
    featuredEl.removeAttribute("srcset");
    if (featuredEl.parentElement && featuredEl.parentElement.tagName === "PICTURE") {
      var sources = featuredEl.parentElement.querySelectorAll("source");
      for (var i = 0; i < sources.length; i += 1) {
        sources[i].remove();
      }
    }
  }

  function hexToRgb(hex) {
    var h = String(hex || "").replace("#", "").trim();
    if (h.length === 3) {
      h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    }
    if (h.length !== 6) return null;
    return {
      r: parseInt(h.slice(0, 2), 16),
      g: parseInt(h.slice(2, 4), 16),
      b: parseInt(h.slice(4, 6), 16),
    };
  }

  function contrastTextColor(hex) {
    var rgb = hexToRgb(hex);
    if (!rgb) return "#ffffff";
    var lum = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
    return lum > 0.62 ? "#1a1a1a" : "#ffffff";
  }

  function injectColorCapsuleCss() {
    if (document.getElementById("havin-color-capsule-css")) return;
    var style = document.createElement("style");
    style.id = "havin-color-capsule-css";
    style.textContent =
      "variant-picker label[data-havin-color-capsule]{" +
      "white-space:nowrap!important;" +
      "overflow:visible!important;" +
      "text-overflow:clip!important;" +
      "min-width:max-content!important;" +
      "width:auto!important;" +
      "max-width:none!important;" +
      "padding-left:1rem!important;" +
      "padding-right:1rem!important;" +
      "transition:none!important;" +
      "}" +
      "variant-picker label[data-havin-color-capsule] .variant-option__button-label__text{" +
      "transition:none!important;" +
      "}" +
      "variant-picker label[data-havin-color-capsule] .variant-option__button-label__pill{" +
      "display:none!important;" +
      "visibility:hidden!important;" +
      "width:0!important;" +
      "height:0!important;" +
      "overflow:hidden!important;" +
      "}" +
      "variant-picker label[data-havin-color-capsule]::before," +
      "variant-picker label[data-havin-color-capsule]::after{" +
      "display:none!important;" +
      "content:none!important;" +
      "background:none!important;" +
      "}" +
      "variant-picker input[type='radio']:checked+label[data-havin-color-capsule][data-havin-selected='1']{" +
      "box-shadow:none!important;" +
      "}";
    document.head.appendChild(style);
  }

  function removeLegacySwatchUi() {
    // Keep active circular .havin-color-swatches UI. Only strip obsolete
    // intermediate style tags from earlier capsule experiments.
    ["havin-variant-capsules-css", "havin-swatch-rules", "havin-selected-capsule-css"].forEach(
      function (id) {
        var node = document.getElementById(id);
        if (node) node.remove();
      }
    );
  }

  function markCircularSwatchActive(wrap, value) {
    if (!wrap) return;
    window.__HAVIN_SUPPRESS_PICKER_OBS__ = true;
    var buttons = wrap.querySelectorAll("[data-havin-swatch]");
    var selected = String(value || "");
    for (var i = 0; i < buttons.length; i += 1) {
      var btn = buttons[i];
      var active = String(btn.dataset.value || "") === selected;
      btn.classList.toggle("havin-color-swatches__btn--active", active);
      btn.setAttribute("aria-selected", active ? "true" : "false");
    }
    window.requestAnimationFrame(function () {
      window.__HAVIN_SUPPRESS_PICKER_OBS__ = false;
    });
  }

  function findColorRadioByValue(picker, value) {
    if (!picker) return null;
    var target = String(value || "");
    var radios = getColorRadios(picker);
    for (var i = 0; i < radios.length; i += 1) {
      if (String(radios[i].value || "") === target) return radios[i];
    }
    return null;
  }

  function selectedColorRadioValue(picker) {
    var radios = getColorRadios(picker);
    for (var i = 0; i < radios.length; i += 1) {
      if (radios[i].checked) return radios[i].value || "";
    }
    return "";
  }

  function circularSwatchUiIsValid(wrap, picker) {
    if (!wrap || !picker || !picker.contains(wrap)) return false;
    var buttons = wrap.querySelectorAll("[data-havin-swatch]");
    if (!buttons.length) return false;
    for (var i = 0; i < buttons.length; i += 1) {
      if (!findColorRadioByValue(picker, buttons[i].dataset.value)) return false;
    }
    return true;
  }

  function syncCircularSwatchSelection() {
    var picker = document.querySelector("variant-picker");
    if (!picker) return;
    var wrap = picker.querySelector(".havin-color-swatches");
    if (!wrap || !circularSwatchUiIsValid(wrap, picker)) {
      injectColorSwatches();
      return;
    }
    markCircularSwatchActive(wrap, selectedColorRadioValue(picker));
  }

  function colorCapsuleParts(label) {
    return {
      pill: label.querySelector(".variant-option__button-label__pill"),
      text: label.querySelector(".variant-option__button-label__text"),
    };
  }

  function clearSelectedIndicator(label) {
    if (!label) return;
    label.removeAttribute("data-havin-selected");
    label.style.setProperty("outline", "none", "important");
    label.style.setProperty("outline-offset", "0", "important");
    label.style.setProperty("box-shadow", "none", "important");
  }

  function applySwatchToLabel(label, value, isSelected) {
    var prerendered = label.getAttribute("data-havin-prerendered") === "1";
    var sw = swatchForName(value);
    var hex = sw.hex || guessHex(value);
    // An explicit hex is the real colour; image swatches are only for colour-less values (patterns).
    var imageSrc = sw.hex ? "" : sw.image_src || "";
    var parts = colorCapsuleParts(label);

    label.setAttribute("data-havin-color-capsule", "1");

    if (parts.pill) {
      parts.pill.style.setProperty("display", "none", "important");
      parts.pill.style.setProperty("visibility", "hidden", "important");
    }

    if (isSelected) {
      label.setAttribute("data-havin-selected", "1");
      label.style.setProperty("outline", "2px solid #111", "important");
      label.style.setProperty("outline-offset", "2px", "important");
    } else {
      clearSelectedIndicator(label);
    }

    label.style.setProperty("box-shadow", "none", "important");
    label.style.setProperty("transition", "none", "important");

    if (prerendered) return;

    if (imageSrc) {
      label.style.setProperty("background-color", "transparent", "important");
      label.style.setProperty("background-image", "url(" + imageSrc + ")", "important");
      label.style.setProperty("background-size", "cover", "important");
      label.style.setProperty("background-position", "center", "important");
      label.style.setProperty("border-color", isSelected ? "#111" : "#ccc", "important");
      label.style.setProperty("color", "#ffffff", "important");
      label.style.setProperty("text-shadow", "0 1px 2px rgba(0,0,0,.45)", "important");
      if (parts.text) {
        parts.text.style.setProperty("color", "#ffffff", "important");
      }
      return;
    }

    if (hex) {
      var fg = contrastTextColor(hex);
      label.style.setProperty("background-color", hex, "important");
      label.style.setProperty("border-color", hex, "important");
      label.style.setProperty("background-image", "none", "important");
      label.style.setProperty("color", fg, "important");
      label.style.setProperty("text-shadow", "none", "important");
      if (parts.text) {
        parts.text.style.setProperty("color", fg, "important");
      }
    }
  }

  function getColorRadios(picker) {
    var radios = picker.querySelectorAll('input[type="radio"]');
    var colorRadios = [];
    for (var i = 0; i < radios.length; i += 1) {
      if (isColorRadio(radios[i])) colorRadios.push(radios[i]);
    }
    return colorRadios;
  }

  function paintAllColorCapsules() {
    var picker = document.querySelector("variant-picker");
    if (!picker) return;

    injectColorCapsuleCss();

    var colorRadios = getColorRadios(picker);
    if (!colorRadios.length) return;

    var selectedValue = "";

    for (var i = 0; i < colorRadios.length; i += 1) {
      var radio = colorRadios[i];
      var value = radio.value || "";
      if (!value) continue;

      var label = capsuleLabelForRadio(picker, radio);
      if (!label) continue;

      if (!radio.dataset.havinColorBound) {
        radio.dataset.havinColorBound = "1";
        radio.addEventListener("change", onColorRadioChange);
      }

      if (label.getAttribute("data-havin-prerendered") === "1") {
        if (radio.checked) {
          label.setAttribute("data-havin-selected", "1");
          label.style.setProperty("outline", "2px solid #111", "important");
          label.style.setProperty("outline-offset", "2px", "important");
        } else {
          clearSelectedIndicator(label);
        }
      } else {
        applySwatchToLabel(label, value, radio.checked);
      }
      if (radio.checked) selectedValue = value;
    }

    if (selectedValue) {
      var resolved = resolveVariantFromSelection();
      if (resolved) applyTitleNow(resolved);
    }
  }

  function variantFromColorValue(colorValue) {
    if (!product || !colorValue) return null;
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i += 1) {
      var v = variants[i];
      if (v.option1 === colorValue || v.option2 === colorValue || v.option3 === colorValue) {
        return v;
      }
    }
    return matchVariantByOptions([colorValue]);
  }

  function onColorRadioChange(event) {
    // Capsule path retained but unused; circular proxy syncs via picker listeners.
    var radio = event && event.target;
    var value = radio && radio.value;
    var variant =
      (value && variantFromColorValue(value)) ||
      readVariantFromPicker() ||
      currentVariant();
    handleVariantChange(variant);
  }

  function afterPickerUpdate(fn) {
    window.requestAnimationFrame(fn);
  }

  function applyTitleForSelectedColor(colorValue) {
    refreshDomRefs();
    if (!titleEl || !colorValue) return;
    var variant = variantFromColorValue(colorValue) || resolveVariantFromSelection();
    applyTitleNow(variant || { option1: colorValue });
  }

  function applyTitleNow(variant) {
    refreshDomRefs();
    if (!variant) return;
    var next = listingTitle(variant);
    if (!next) return;

    refreshDomRefs();
    if (titleEl && String(titleEl.textContent || "").trim() !== next) {
      titleEl.textContent = next;
    }

    var stickyTitle = document.querySelector(".sticky-add-to-cart__title");
    if (stickyTitle && String(stickyTitle.textContent || "").trim() !== next) {
      stickyTitle.textContent = next;
    }
  }

  function updateTitle(variant) {
    applyTitleNow(variant);
  }

  function escapeHtml(text) {
    return String(text || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function looksLikeHtml(text) {
    return /<\/?[a-z][\s\S]*>/i.test(String(text || ""));
  }

  function formatVariantDescription(text) {
    var raw = String(text || "").trim();
    if (!raw) return "";
    if (looksLikeHtml(raw)) return raw;
    return escapeHtml(raw).replace(/\r\n|\r|\n/g, "<br>");
  }

  function normalizeDescText(html) {
    var tmp = document.createElement("div");
    tmp.innerHTML = String(html || "");
    return String(tmp.textContent || "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  }

  function descriptionLookup(variant) {
    var key = optionKeyFromVariant(variant);
    if (!key) return "";
    if (Object.prototype.hasOwnProperty.call(variantDescriptions, key)) {
      return String(variantDescriptions[key] || "").trim();
    }
    // Tolerate trailing-empty option slots vs single-option keys
    var compact = key.replace(/\|+$/g, "");
    if (
      compact &&
      Object.prototype.hasOwnProperty.call(variantDescriptions, compact)
    ) {
      return String(variantDescriptions[compact] || "").trim();
    }
    var withTrail = compact + "||";
    if (Object.prototype.hasOwnProperty.call(variantDescriptions, withTrail)) {
      return String(variantDescriptions[withTrail] || "").trim();
    }
    return "";
  }

  function findDescriptionHost() {
    var marked = document.querySelector('[data-havin-variant-description="1"]');
    if (marked) return marked;

    var target = normalizeDescText(productDescriptionHtml);
    var roots = document.querySelectorAll(
      ".product-details, .product-information, .havin-variant-description"
    );
    var best = null;
    var bestScore = 0;

    for (var i = 0; i < roots.length; i += 1) {
      var root = roots[i];
      var candidates = root.querySelectorAll(
        ".havin-variant-description, [data-havin-variant-description], .product-description, [class*='product-description'], rte-formatter.rte, .text-block.rte, .rte, rte-formatter"
      );
      for (var j = 0; j < candidates.length; j += 1) {
        var el = candidates[j];
        if (!el || el.closest("media-gallery")) continue;
        if (el.querySelector("[data-havin-variant-title]")) continue;
        if (el.getAttribute("data-havin-variant-title") === "1") continue;
        // Prefer explicit wrapper
        if (
          el.getAttribute("data-havin-variant-description") === "1" ||
          el.classList.contains("havin-variant-description")
        ) {
          el.setAttribute("data-havin-variant-description", "1");
          return el;
        }
        var text = normalizeDescText(el.innerHTML);
        if (!text || text.length < 8) continue;
        if (
          target &&
          (text === target ||
            (target.length > 20 && text.indexOf(target) !== -1) ||
            (text.length > 20 && target.indexOf(text) !== -1))
        ) {
          el.setAttribute("data-havin-variant-description", "1");
          return el;
        }
        if (text.length > bestScore) {
          bestScore = text.length;
          best = el;
        }
      }
    }

    // Last resort: longest RTE in product details (skip tiny labels)
    if (best && bestScore >= 40) {
      best.setAttribute("data-havin-variant-description", "1");
      return best;
    }
    return null;
  }

  function applyDescription(variant) {
    var host = findDescriptionHost();
    if (!host) return;
    if (!host.__havinProductDescriptionHtml) {
      host.__havinProductDescriptionHtml =
        productDescriptionHtml || host.innerHTML || "";
    }
    var custom = descriptionLookup(variant);
    if (custom) {
      host.innerHTML = formatVariantDescription(custom);
    } else {
      host.innerHTML =
        host.__havinProductDescriptionHtml || productDescriptionHtml || "";
    }
  }

  function onVariantChange(variant) {
    if (!variant) return;
    filterGalleryForVariant(variant);
    // Title already applied in handleVariantChange; keep a cheap ensure.
    updateTitle(variant);
    applyDescription(variant);
    // Active-state sync already done in handleVariantChange when present.
  }

  function handleVariantChange(variant) {
    var token = (handleVariantChange._token = (handleVariantChange._token || 0) + 1);
    afterPickerUpdate(function () {
      // Coalesce bursty picker/theme events from a single Color click.
      if (token !== handleVariantChange._token) return;
      window.__HAVIN_IN_VARIANT_CHANGE__ = true;
      try {
        product = loadProduct() || product;
        var resolved = variant || resolveVariantFromSelection();
        if (!resolved) return;
        syncVariantIdToForm(resolved);
        syncUrlVariant(resolved);
        applyTitleNow(resolved);
        syncCircularSwatchSelection();
        onVariantChange(resolved);
      } finally {
        window.__HAVIN_IN_VARIANT_CHANGE__ = false;
      }
    });
  }

  function variantFromId(id) {
    if (!product || !product.variants) return null;
    var variants = product.variants;
    for (var i = 0; i < variants.length; i += 1) {
      if (Number(variants[i].id) === Number(id)) return variants[i];
    }
    return null;
  }

  function variantIdFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      var id = Number(params.get("variant"));
      if (!Number.isNaN(id) && id > 0) return id;
    } catch (e) {}
    return null;
  }

  function syncVariantIdToForm(variant) {
    if (!variant || variant.id == null) return;
    var form =
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector(".product-form") ||
      document.querySelector("[data-product-form]");
    if (!form) return;
    var idInput =
      form.querySelector('input[name="id"]') ||
      form.querySelector('select[name="id"]');
    if (!idInput) return;
    var next = String(variant.id);
    if (String(idInput.value) === next) return;
    idInput.value = next;
    idInput.setAttribute("value", next);
    // Avoid re-entrant handleVariantChange via form/id observers while we
    // are already processing this variant change.
    if (window.__HAVIN_IN_VARIANT_CHANGE__) return;
    idInput.dispatchEvent(new Event("input", { bubbles: true }));
    idInput.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function syncUrlVariant(variant) {
    if (!variant || variant.id == null) return;
    try {
      var url = new URL(window.location.href);
      if (url.searchParams.get("variant") === String(variant.id)) return;
      url.searchParams.set("variant", String(variant.id));
      // Keep lastUrlVariant in sync so our own replaceState does not
      // schedule a full section reinit on every Color click.
      lastUrlVariant = Number(variant.id);
      history.replaceState({}, "", url.toString());
    } catch (e) {}
  }

  function resolveVariantFromSelection() {
    product = loadProduct() || product;
    var picker = document.querySelector("variant-picker");
    if (picker) {
      var checked = picker.querySelector('input[type="radio"]:checked');
      if (checked && checked.value && isColorRadio(checked)) {
        var fromColor = variantFromColorValue(checked.value);
        if (fromColor) return fromColor;
      }
    }
    return readVariantFromPicker() || readVariantFromForm() || currentVariant();
  }

  function readVariantFromForm(form) {
    form =
      form ||
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector(".product-form") ||
      document.querySelector("[data-product-form]");
    if (!form || !product) return null;
    var idInput = form.querySelector('[name="id"]');
    var id = idInput ? Number(idInput.value) : NaN;
    if (!Number.isNaN(id)) {
      var byId = variantFromId(id);
      if (byId) return byId;
    }

    var urlId = variantIdFromUrl();
    if (urlId) {
      var fromUrl = variantFromId(urlId);
      if (fromUrl) return fromUrl;
    }

    var selects = form.querySelectorAll('select[name^="options"]');
    if (!selects.length) return null;
    var selected = [];
    for (var i = 0; i < selects.length; i += 1) {
      selected.push(selects[i].value || "");
    }
    return matchVariantByOptions(selected);
  }

  function matchVariantByOptions(selectedValues) {
    if (!product || !product.variants) return null;
    var cleaned = selectedValues.filter(Boolean);
    var variants = product.variants;

    for (var i = 0; i < variants.length; i += 1) {
      var variant = variants[i];
      var opts = [variant.option1, variant.option2, variant.option3].filter(Boolean);
      if (!opts.length) continue;
      if (opts.length !== cleaned.length) continue;
      var match = true;
      for (var j = 0; j < opts.length; j += 1) {
        if (opts[j] !== cleaned[j]) {
          match = false;
          break;
        }
      }
      if (match) return variant;
    }

    if (cleaned.length === 1) {
      for (var k = 0; k < variants.length; k += 1) {
        if (variants[k].option1 === cleaned[0]) return variants[k];
      }
    }
    return variants[0] || null;
  }

  function readVariantFromPicker() {
    if (!product) return null;
    var picker = document.querySelector("variant-picker");
    if (!picker) return null;

    var selectedByGroup = {};
    var radios = picker.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i += 1) {
      var radio = radios[i];
      if (radio.checked) selectedByGroup[radio.name] = radio.value;
    }

    var selectedValues = Object.keys(selectedByGroup)
      .sort()
      .map(function (key) {
        return selectedByGroup[key];
      });
    if (!selectedValues.length) return product.variants[0] || null;
    return matchVariantByOptions(selectedValues);
  }

  function currentVariant() {
    var form =
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector(".product-form") ||
      document.querySelector("[data-product-form]");
    return (
      (form && readVariantFromForm(form)) ||
      readVariantFromPicker() ||
      variantFromId(variantIdFromUrl()) ||
      (product && product.variants && product.variants[0]) ||
      null
    );
  }

  function getColorSwatchList() {
    var keys = Object.keys(optionSwatches || {});
    for (var i = 0; i < keys.length; i += 1) {
      if (/color|colour/i.test(keys[i])) {
        return optionSwatches[keys[i]] || [];
      }
    }
    return [];
  }

  function swatchForName(name) {
    var list = getColorSwatchList();
    var target = String(name || "").toLowerCase();
    for (var i = 0; i < list.length; i += 1) {
      if (String(list[i].name || "").toLowerCase() === target) return list[i];
    }
    return { name: name, hex: guessHex(name) };
  }

  function colorOptionIndex() {
    if (!product || !product.options) return -1;
    for (var i = 0; i < product.options.length; i += 1) {
      if (/color|colour/i.test(optionNameAt(i))) return i;
    }
    // Only Color/Colour — never treat Size/Material/etc. as color.
    return -1;
  }

  function isColorRadio(radio) {
    if (!radio) return false;

    // Prefer DOM signals so circular proxy works before product JSON is ready.
    var optName = radio.getAttribute("data-option-name") || "";
    if (/color|colour/i.test(optName)) return true;

    var colorIdx = colorOptionIndex();
    if (colorIdx < 0) {
      return isColorOptionGroup(
        radio.closest("fieldset, [data-option-index]") || radio.parentElement
      );
    }

    var group = radio.closest("fieldset, [data-option-index]");
    if (!group) return isColorOptionGroup(radio.parentElement);
    var idx = group.getAttribute("data-option-index");
    if (idx !== null && Number(idx) === colorIdx) return true;
    return isColorOptionGroup(group);
  }

  function isColorOptionGroup(groupEl) {
    if (!groupEl) return false;
    var label =
      groupEl.querySelector("legend, .variant-picker__label, label, [class*='label']") ||
      groupEl.previousElementSibling;
    var text = label ? String(label.textContent || "").toLowerCase() : "";
    if (/color|colour/.test(text)) return true;
    if (product && product.options) {
      var groups = document.querySelectorAll(
        "variant-picker fieldset, variant-picker [data-option-index]"
      );
      var colorIdx = colorOptionIndex();
      if (colorIdx >= 0 && groups[colorIdx] === groupEl) return true;
    }
    return false;
  }

  function capsuleLabelForRadio(picker, radio) {
    return (
      picker.querySelector('label[for="' + radio.id + '"]') ||
      radio.closest("label") ||
      radio.parentElement
    );
  }

  function findColorOptionControl(form) {
    if (!form) return null;
    var selects = form.querySelectorAll('select[name^="options"]');
    for (var i = 0; i < selects.length; i += 1) {
      var select = selects[i];
      var label =
        (select.id &&
          document.querySelector('label[for="' + select.id + '"]')) ||
        select.closest("fieldset") ||
        select.parentElement;
      var labelText = label ? String(label.textContent || "").toLowerCase() : "";
      if (/color|colour/.test(labelText)) return select;
    }
    if (product && product.options) {
      for (var j = 0; j < product.options.length; j += 1) {
        var optName = optionNameAt(j).toLowerCase();
        if (/color|colour/.test(optName)) {
          return form.querySelector('select[name="options[' + j + ']"]') || null;
        }
      }
    }
    return null;
  }

  function clearCircularSwatchUi(picker) {
    if (!picker) return;
    var wraps = picker.querySelectorAll(".havin-color-swatches");
    for (var i = 0; i < wraps.length; i += 1) {
      wraps[i].remove();
    }
    var proxied = picker.querySelectorAll(
      'fieldset[data-havin-color-proxy="1"], [data-havin-color-proxy="1"]'
    );
    for (var j = 0; j < proxied.length; j += 1) {
      proxied[j].removeAttribute("data-havin-color-proxy");
    }
    var capsules = picker.querySelectorAll("[data-havin-color-capsule]");
    for (var k = 0; k < capsules.length; k += 1) {
      capsules[k].removeAttribute("data-havin-color-capsule");
      capsules[k].removeAttribute("data-havin-selected");
      capsules[k].removeAttribute("data-havin-prerendered");
    }
  }

  function injectColorSwatches() {
    var picker = document.querySelector("variant-picker");
    if (!picker) return;

    var colorRadios = getColorRadios(picker);
    if (!colorRadios.length) {
      // Non-color products (Size/Material/Fragrance/…) keep Horizon capsules.
      clearCircularSwatchUi(picker);
      return;
    }

    var fieldset = colorRadios[0].closest("fieldset");
    if (!fieldset) return;

    fieldset.setAttribute("data-havin-color-proxy", "1");

    var wraps = picker.querySelectorAll(".havin-color-swatches");
    var wrap = null;
    for (var w = 0; w < wraps.length; w += 1) {
      if (
        !wrap &&
        fieldset.contains(wraps[w]) &&
        circularSwatchUiIsValid(wraps[w], picker)
      ) {
        wrap = wraps[w];
      } else {
        wraps[w].remove();
      }
    }

    if (wrap) {
      markCircularSwatchActive(wrap, selectedColorRadioValue(picker));
      return;
    }

    wrap = document.createElement("div");
    wrap.className = "havin-color-swatches";
    wrap.dataset.havinSwatches = "1";
    wrap.setAttribute("role", "listbox");
    wrap.setAttribute("aria-label", "Color");

    var seen = {};
    for (var i = 0; i < colorRadios.length; i += 1) {
      var radio = colorRadios[i];
      var value = radio.value || "";
      if (!value || seen[value]) continue;
      seen[value] = true;

      var sw = swatchForName(value);
      var hex = sw.hex || guessHex(value);
      var imageSrc = sw.hex ? "" : sw.image_src || "";

      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "havin-color-swatches__btn";
      btn.dataset.havinSwatch = "1";
      btn.dataset.value = value;
      btn.title = value;
      btn.setAttribute("aria-label", value);
      btn.setAttribute("role", "option");

      if (imageSrc) {
        btn.style.backgroundImage = "url(" + imageSrc + ")";
        btn.style.backgroundSize = "cover";
        btn.style.backgroundPosition = "center";
        btn.style.backgroundColor = "transparent";
      } else if (hex) {
        // background-image resists Chrome Auto Dark better than background-color alone.
        btn.style.backgroundColor = hex;
        btn.style.backgroundImage = "linear-gradient(" + hex + "," + hex + ")";
      } else {
        btn.classList.add("havin-color-swatches__btn--empty");
      }

      btn.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        var livePicker = document.querySelector("variant-picker");
        var nextValue = this.dataset.value;
        var liveWrap =
          (livePicker && livePicker.querySelector(".havin-color-swatches")) || wrap;
        // Instant visual feedback; Shopify radio remains source of truth and
        // syncCircularSwatchSelection() reconciles after variant change.
        markCircularSwatchActive(liveWrap, nextValue);
        var match = findColorRadioByValue(livePicker, nextValue);
        if (!match) return;
        if (!match.checked) {
          match.click();
        }
      });

      wrap.appendChild(btn);
    }

    if (!wrap.childNodes.length) return;

    window.__HAVIN_SUPPRESS_PICKER_OBS__ = true;
    var legend = fieldset.querySelector("legend");
    if (legend && legend.nextSibling) {
      fieldset.insertBefore(wrap, legend.nextSibling);
    } else {
      fieldset.appendChild(wrap);
    }
    window.requestAnimationFrame(function () {
      window.__HAVIN_SUPPRESS_PICKER_OBS__ = false;
    });

    markCircularSwatchActive(wrap, selectedColorRadioValue(picker));
  }

  function titleNeedsFix() {
    refreshDomRefs();
    if (!titleEl) return false;
    var text = String(titleEl.textContent || "").trim();
    var variant = resolveVariantFromSelection() || currentVariant();
    if (!variant) return false;
    var expectedFromVariant = listingTitle(variant);
    return expectedFromVariant && text !== expectedFromVariant;
  }

  function watchTitleElement() {
    refreshDomRefs();
    var titleRoot =
      document.querySelector('.product-details [data-havin-variant-title="1"]') ||
      document.querySelector(".product-details .text-block h4") ||
      document.querySelector('.product-details a[ref="productTitleLink"]') ||
      document.querySelector(".product-details .text-block");
    if (!titleRoot || titleRoot.dataset.havinTitleWatch === "1") return;
    titleRoot.dataset.havinTitleWatch = "1";

    var titleObserver = new MutationObserver(function () {
      refreshDomRefs();
      if (titleNeedsFix()) {
        applyTitleNow(resolveVariantFromSelection() || currentVariant());
      }
    });
    titleObserver.observe(titleRoot, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function watchPickerElement() {
    var picker = document.querySelector("variant-picker");
    if (!picker || picker.dataset.havinPickerWatch === "1") return;
    picker.dataset.havinPickerWatch = "1";

    // childList only — do NOT observe descendant attributes/class.
    // Watching subtree class changes re-entered handleVariantChange whenever
    // circular active-state classes toggled (multi-call storm / lag).
    var pickerObserver = new MutationObserver(function (mutations) {
      if (window.__HAVIN_SUPPRESS_PICKER_OBS__) return;
      var needs = false;
      for (var i = 0; i < mutations.length; i += 1) {
        if (mutations[i].type === "childList" && mutations[i].addedNodes.length) {
          needs = true;
          break;
        }
      }
      if (!needs) return;
      afterPickerUpdate(function () {
        syncCircularSwatchSelection();
        handleVariantChange(resolveVariantFromSelection());
      });
    });
    pickerObserver.observe(picker, {
      childList: true,
      subtree: true,
      attributes: false,
    });

    var radios = picker.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i += 1) {
      if (radios[i].dataset.havinCheckedWatch === "1") continue;
      radios[i].dataset.havinCheckedWatch = "1";
      var radioObserver = new MutationObserver(function () {
        if (window.__HAVIN_SUPPRESS_PICKER_OBS__) return;
        afterPickerUpdate(syncCircularSwatchSelection);
      });
      radioObserver.observe(radios[i], {
        attributes: true,
        attributeFilter: ["checked"],
      });
    }
  }

  function sectionNeedsReinit(mutations) {
    for (var i = 0; i < mutations.length; i += 1) {
      var mutation = mutations[i];
      if (mutation.type !== "childList") continue;
      var nodes = mutation.addedNodes;
      for (var j = 0; j < nodes.length; j += 1) {
        var node = nodes[j];
        if (!node || node.nodeType !== 1) continue;
        if (
          node.matches &&
          (node.matches("variant-picker, media-gallery, .text-block") ||
            (node.querySelector &&
              node.querySelector('variant-picker, media-gallery, a[ref="productTitleLink"]')))
        ) {
          return true;
        }
      }
    }
    return false;
  }

  function watchProductSection() {
    var root =
      document.querySelector(".product-information") ||
      document.querySelector("[data-testid='product-information-details']") ||
      document.body;
    if (!root || root.dataset.havinSectionWatch === "1") return;
    root.dataset.havinSectionWatch = "1";

    var sectionObserver = new MutationObserver(function (mutations) {
      if (sectionNeedsReinit(mutations)) {
        scheduleReinit();
      }
    });
    sectionObserver.observe(root, { childList: true, subtree: true });
  }

  function watchVariantIdInput(form) {
    if (!form || form.dataset.havinVariantWatch === "1") return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;
    form.dataset.havinVariantWatch = "1";

    var observer = new MutationObserver(function () {
      if (window.__HAVIN_IN_VARIANT_CHANGE__) return;
      handleVariantChange(currentVariant());
    });
    observer.observe(idInput, { attributes: true, attributeFilter: ["value"] });

    idInput.addEventListener("change", function () {
      if (window.__HAVIN_IN_VARIANT_CHANGE__) return;
      handleVariantChange(currentVariant());
    });
  }

  function scheduleReinit() {
    if (reinitTimer) window.cancelAnimationFrame(reinitTimer);
    reinitTimer = window.requestAnimationFrame(function () {
      product = loadProduct() || product;
      refreshDomRefs();
      removeLegacySwatchUi();
      if (titleEl) delete titleEl.dataset.havinTitleWatch;
      var titleRoot = document.querySelector(".product-details .text-block");
      if (titleRoot) delete titleRoot.dataset.havinTitleWatch;
      var picker = document.querySelector("variant-picker");
      if (picker) {
        delete picker.dataset.havinPickerBound;
        delete picker.dataset.havinPickerWatch;
      }
      bindVariantListeners();
      injectColorSwatches();
      var variant = currentVariant();
      if (variant) onVariantChange(variant);
    });
  }

  function watchUrlVariant() {
    var urlId = variantIdFromUrl();
    if (urlId && urlId !== lastUrlVariant) {
      lastUrlVariant = urlId;
      scheduleReinit();
    }
  }

  function bindHistoryListeners() {
    if (window.__HAVIN_HISTORY_BOUND__) return;
    window.__HAVIN_HISTORY_BOUND__ = true;

    window.addEventListener("popstate", watchUrlVariant);

    var pushState = history.pushState;
    history.pushState = function () {
      var result = pushState.apply(history, arguments);
      watchUrlVariant();
      return result;
    };

    var replaceState = history.replaceState;
    history.replaceState = function () {
      var result = replaceState.apply(history, arguments);
      watchUrlVariant();
      return result;
    };
  }

  function bindVariantListeners() {
    if (!window.__HAVIN_VARIANT_CHANGE_BOUND__) {
      window.__HAVIN_VARIANT_CHANGE_BOUND__ = true;
      document.addEventListener("variant:change", function (event) {
        var detail = event.detail || {};
        handleVariantChange(detail.variant || currentVariant());
      });
    }

    var picker = document.querySelector("variant-picker");
    if (picker && !picker.dataset.havinPickerBound) {
      picker.dataset.havinPickerBound = "1";
      picker.addEventListener("change", function () {
        handleVariantChange(readVariantFromPicker());
      });
      // Do not also bind click — radio.click()/label clicks already emit change.
      // A second click listener caused duplicate variant-change work per Color tap.
    }

    var form =
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector(".product-form") ||
      document.querySelector("[data-product-form]");
    if (form) {
      watchVariantIdInput(form);
      if (!form.dataset.havinFormBound) {
        form.dataset.havinFormBound = "1";
        form.addEventListener("change", function () {
          if (window.__HAVIN_IN_VARIANT_CHANGE__) return;
          handleVariantChange(readVariantFromForm(form) || readVariantFromPicker());
        });
      }
    }

    injectColorSwatches();
    watchPickerElement();
    watchTitleElement();
    watchProductSection();
    bindHistoryListeners();
  }

  removeLegacySwatchUi();
  applyInitialTitle();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyInitialTitle, { once: true });
  }
  bindVariantListeners();
  lastUrlVariant = variantIdFromUrl();
  ensureProductThen(function () {
    injectColorSwatches();
    onVariantChange(currentVariant());
  });
})();
